import React from 'react'
import PDFObject from 'pdfobject'

import { ZariContext } from '_zari/context'
import { Row, Col } from '_zari/core'

import * as FacturacionService from 'services/facturacion.service'

const EstandarFormat = ({ md, pdfHash }) => {
  const __zariContext = React.useContext(ZariContext)

  React.useEffect(() => {
    FacturacionService.self
      .descargarPdfxId(pdfHash)
      .then(({ data }) => {
        var file = new Blob([data], { type: 'application/pdf' })
        var fileURL = URL.createObjectURL(file)

        PDFObject.embed(fileURL, '#pdf-estandarformat-viewer', {
          height: '70vh',
          pdfOpenParams: { view: 'FitV', page: '1' }
        })
      })
      .catch(() => {
        __zariContext.snack('warning', 'La venta se completo pero no se pudo descargar el documento.')
      })
  }, [__zariContext, pdfHash])

  return (
    <Col md={md}>
      <Row className='mb-2'>
        <Col md={12} className='text-center'>
          <h4>IMPRESIÓN PRINCIPAL</h4>
        </Col>
      </Row>
      <Row>
        <Col id='pdf-estandarformat-viewer' md={12}></Col>
      </Row>
    </Col>
  )
}

export default React.memo(EstandarFormat)
